import React from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ConfirmationDialog from "../../components/dialogs/confirmationDialog/ConfirmationDialog";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import CamplaCoreService from "../../services/CamplaCoreService";
import StorageService from "../../services/StorageService";
import EditCatalogDialog from "./dialogs/editCatalogDialog/EditCatalogDialog";
import SoftwareCatalogInfoCard from "./softwareCatalogInfoCard/SoftwareCatalogInfoCard";
import PackagesTab from "./tabs/packagesTab/PackagesTab";
import DescriptionTab from "../../components/descriptionTab/DescriptionTab";

class SingleSoftwareCatalog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      softwareCatalog: null,
      apiError: "",
      dialogApiError: "",
      showConfirmationDialog: false,
      showEditCatalogDialog: false,
      confirmationDialogTitle: "",
      confirmationDialogBody: "",
      confirmationDialogRightButtonVariant: "primary",
      confirmationDialogLeftButtonVariant: "secondary"
    };

    this.fetchData = this.fetchData.bind(this);
    this.onUpdateCatalog = this.onUpdateCatalog.bind(this);
    this.onUpdatePackages = this.onUpdatePackages.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  async componentDidMount() {
    const cachedCatalog = StorageService.getReferenceType(
      "singleSoftwareCatalog"
    );
    if (typeof this.props.location.state !== "undefined") {
      const { softwareCatalog } = this.props.location.state;
      if (cachedCatalog && cachedCatalog._id === softwareCatalog._id) {
        this.setState({ softwareCatalog: cachedCatalog });
      } else {
        this.setState({ softwareCatalog });
      }
    } else if (cachedCatalog) {
      this.setState({ softwareCatalog: cachedCatalog });
    }

    await this.fetchData();
  }

  async fetchData() {
    try {
      const softwareCatalog = await CamplaCoreService.getSoftwareCatalog(
        this.props.match.params.id
      );
      StorageService.set("singleSoftwareCatalog", softwareCatalog);
      this.setState({
        softwareCatalog
      });
    } catch (err) {
      await this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  onEdit() {
    this.setState({ showEditCatalogDialog: true });
  }

  async onUpdateCatalog(softwareCatalog) {
    try {
      const updatedCatalog = await CamplaCoreService.updateSoftwareCatalog(
        this.state.softwareCatalog._id,
        softwareCatalog
      );
      const clonedSoftwareCatalog = Object.assign(
        {},
        this.state.softwareCatalog
      );
      for (const key in softwareCatalog) {
        clonedSoftwareCatalog[key] = updatedCatalog[key];
      }
      StorageService.set("singleSoftwareCatalog", clonedSoftwareCatalog);
      this.setState({
        softwareCatalog: clonedSoftwareCatalog,
        showEditCatalogDialog: false
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleSoftwareCatalog.APIError.PreconditionFailed",
            NOT_FOUND: "SingleSoftwareCatalog.APIError.NotFound"
          },
          this.props.t
        )
      });
    }
  }

  onUpdatePackages(packages) {
    const clonedSoftwareCatalog = Object.assign({}, this.state.softwareCatalog);
    clonedSoftwareCatalog.packages = [...packages];
    this.setState({
      softwareCatalog: clonedSoftwareCatalog
    });
  }

  render() {
    const { t } = this.props;
    return !this.state.softwareCatalog ? (
      <div />
    ) : (
      <div>
        <ConfirmationDialog
          title={this.state.confirmationDialogTitle}
          body={this.state.confirmationDialogBody}
          show={this.state.showConfirmationDialog}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              showConfirmationDialog: false
            })
          }
          onSubmit={this.state.onConfirmationDialogSubmit}
          confirmButtonVariant={
            this.state.confirmationDialogRightButtonVariant
          }
          cancelButtonVariant={this.state.confirmationDialogLeftButtonVariant}
        />
        <EditCatalogDialog
          show={this.state.showEditCatalogDialog}
          onHide={() => this.setState({ showEditCatalogDialog: false })}
          softwareCatalog={this.state.softwareCatalog}
          onUpdateCatalog={this.onUpdateCatalog}
        />
        <Container className="mt-3">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <SoftwareCatalogInfoCard
                softwareCatalog={this.state.softwareCatalog}
                onEdit={this.onEdit}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Tabs defaultActiveKey="1">
                <Tab
                    eventKey="1"
                    tabClassName="item-link"
                    title={t("SingleSoftwareCatalog.DescriptionTabTitle")}
                >
                  <DescriptionTab
                      text={this.state.softwareCatalog.description}
                      lang={this.props.i18n.language}
                  />
                </Tab>
                <Tab
                  eventKey="2"
                  tabClassName="item-link"
                  title={t("SingleSoftwareCatalog.PackagesTab.Title")}
                >
                  <PackagesTab
                    softwareCatalog={this.state.softwareCatalog}
                    onUpdatePackages={this.onUpdatePackages}
                  />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(SingleSoftwareCatalog);
